import { SoftwareFeaturesConfig, SoftwareFeature } from '../utils/types/SoftwareFeaturesTypes';

const DASHBOARD_FEATURES: ReadonlyArray<SoftwareFeature> = [
  { id: 'realtime-dashboard', text: 'Real-time, 24-hour, soft-pull dashboard' },
  { id: 'bureau-access', text: 'Full bureau access' },
  { id: 'user-interface', text: 'User-friendly interface' },
  { id: 'prequalification', text: 'Pre-qualification mitigation' },
  { id: 'client-management', text: 'Full client management' },
  { id: 'soft-pulls', text: 'Soft credit pulls' },
  { id: 'differential-report', text: 'Differential report on Tri-merge soft pulls' },
  { id: 'neatt-referrals', text: 'Client referrals to NEATT department' },
  { id: 'multiple-users', text: 'Multiple users for company accounts' },
  { id: 'adaptable-cms', text: 'Adaptable CMS for small businesses' }
];

export const SOFTWARE_FEATURES_CONFIG: SoftwareFeaturesConfig = {
  title: 'Dashboard Features',
  features: DASHBOARD_FEATURES,
  backgroundStyle: 'bg-white', 
  gridColumns: 'grid-cols-2 md:grid-cols-3 lg:grid-cols-5' 
};


